import { createFileRoute } from '@tanstack/react-router';
import { call } from '@hlt/web-kit/api';
import { authTimeoutMs } from '@/features/auth/auth-error-message';
import { safeNext } from '@/features/auth/safe-next';
import { SignInPage } from '@/features/auth/sign-in-page';

export const Route = createFileRoute('/auth/sign-in')({
    validateSearch: (search: Record<string, unknown>): { next?: string; error?: 'social' } => ({
        ...(typeof search.next === 'string' ? { next: search.next } : {}),
        // Set by the provider callback when the identity is not linked to an account.
        ...(search.error === 'social' ? { error: 'social' as const } : {}),
    }),
    // Already signed in (for example a tool sent the person here after a race): continue right away. When
    // HLT Cloud does not answer, the form still opens and says so on submit.
    beforeLoad: async ({ search }) => {
        const session = await call('getSession', { timeoutMs: authTimeoutMs }).catch(() => null);
        if (!session || session.mfaRequired) return;
        window.location.replace(safeNext(search.next));
        // The page is unloading; never render the form meanwhile.
        await new Promise<never>(() => undefined);
    },
    component: function SignInRoute() {
        const { next, error } = Route.useSearch();
        return <SignInPage next={next} socialError={error === 'social'} />;
    },
});
